import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AuthorBio = ({ author }) => {
  if (!author) return null;

  return (
    <div className="bg-white rounded-2xl shadow-soft border border-accent-100 p-8 my-12">
      <div className="flex items-start space-x-6">
        <img
          src={author.avatar}
          alt={author.name}
          className="w-20 h-20 rounded-full object-cover flex-shrink-0"
        />
        
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            <h3 className="font-heading font-bold text-xl text-accent-800">
              {author.name}
            </h3>
            {author.isVerified && (
              <Icon name="CheckCircle" size={20} className="text-primary" />
            )}
          </div>
          
          <p className="text-sm text-accent-600 mb-3">
            {author.credentials}
          </p>
          
          <p className="text-accent-700 leading-relaxed mb-4">
            {author.bio}
          </p>
          
          {author.socialLinks && (
            <div className="flex items-center space-x-4">
              {author.socialLinks.twitter && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => window.open(`https://twitter.com/${author.socialLinks.twitter}`, '_blank')}
                  className="text-accent-600 hover:text-blue-500"
                >
                  <Icon name="Twitter" size={16} className="mr-2" />
                  Twitter
                </Button>
              )}
              {author.socialLinks.linkedin && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => window.open(`https://linkedin.com/in/${author.socialLinks.linkedin}`, '_blank')}
                  className="text-accent-600 hover:text-blue-700"
                >
                  <Icon name="Linkedin" size={16} className="mr-2" />
                  LinkedIn
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthorBio;